import React from 'react';

import { Form, FormItemProps, Select } from 'antd';
import { t } from 'i18next';

import { Role } from 'features/user/store/types';
import { rolesForEdit, rolesTitles } from 'features/user/utils/const';

type Props = FormItemProps;

export const SelectUserRole = ({ ...formProps }: Props) => (
  <Form.Item
    label={t('role', 'Роль')}
    name="role"
    {...formProps}
  >
    <Select<Role>>
      {rolesForEdit.map((role) => (
        <Select.Option key={role} value={role}>
          {rolesTitles[role] ?? role}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);
